(ns ui.editor2.sidebar-panel-sticker)

(defn icon [selected?]
  [:svg#Flat
   {:fill "currentColor"
    :stroke-width "10"
    :stroke "currentColor"
    :width "24"
    :height "24"
    :viewBox "0 0 256 256"
    :class ["size-6" (when-not selected? "text-slate-400")]}
   [:path
    {:d "M128,84a44,44,0,1,0,44,44A44.04978,44.04978,0,0,0,128,84Zm0,80a36,36,0,1,1,36-36A36.04061,36.04061,0,0,1,128,164ZM172,32H84A52.059,52.059,0,0,0,32,84v88a52.059,52.059,0,0,0,52,52h88a52.059,52.059,0,0,0,52-52V84A52.059,52.059,0,0,0,172,32Zm44,140a44.04978,44.04978,0,0,1-44,44H84a44.04978,44.04978,0,0,1-44-44V84A44.04978,44.04978,0,0,1,84,40h88a44.04978,44.04978,0,0,1,44,44ZM188,76a8,8,0,1,1-8-8A8.00917,8.00917,0,0,1,188,76Z"}]])

(defn sticker-entry
  [selected?]
  [:div
   {:class ["relative" "flex" "pt-3" "pb-3" "pl-2" "pr-2" "flex-col" "justify-center" "items-center" "gap-1" "rounded-lg" "cursor-pointer" "hover:bg-gray-600"
            (when selected?
              "bg-gray-800")]
    :on {:click [[:store/assoc-in [:editor2 :sidebar-panel] :sticker]]}}
   [:span
    {:class ["absolute" "top-0" "right-0" "px-1.5" "py-0.5" "text-[9px]" "font-bold" "leading-none" "text-white" "bg-red-500" "rounded-full" "uppercase" "tracking-wide"]}
    "NEW"]
   (icon selected?)
   [:span
    {:class ["text-center" "text-xs" "font-medium" (when-not selected? "text-slate-400")]}
    "Sticker"]])

(defn panel
  [state]
  [:div
   {:class ["flex" "flex-col" "gap-2" "w-full"]}
   [:ul.grid.grid-cols-1.gap-6.lg:grid-cols-1

    [:li.col-span-1.bg-white.rounded-lg.shadow.divide-y.divide-gray-200
     [:button.w-full.flex.items-center.justify-center.rounded-md.p-2
      {:type "button"
       :on {:click [[:ui/modal-open
                     :modals/editor2-hashtag-modal
                     {:source :editor2}                        ;; params map
                     ]]}}
      [:span
       {:style {:fontFamily "AvenyT"
                :-webkit-background-clip "text"
                :-webkit-text-fill-color "transparent"
                :background-image "linear-gradient(90deg, #f58c5c, #ff4f99)"}}
       "#HASHTAG"]]]

    [:li.col-span-1.bg-white.rounded-lg.shadow.divide-y.divide-gray-200
     [:button.w-full.flex.items-center.justify-center.rounded-md.p-2
      {:type "button"
       :on {:click [[:ui/modal-open
                     :modals/editor2-usermention-modal
                     {:source :editor2}                        ;; params map
                     ]]}}
      [:span
       {:style {:fontFamily "AvenyT"
                :-webkit-background-clip "text"
                :-webkit-text-fill-color "transparent"
                :background-image "linear-gradient(90deg, #df6744, #ebe550)"}}
       "@MENTION"]]]

    [:li.col-span-1.rounded-lg.shadow.divide-y.divide-gray-200.bg-white
     [:button.w-full.flex.items-center.justify-center.rounded-md.p-2
      {:type "button"
       :on {:click [[:ui/modal-open
                     :modals/editor2-link-modal
                     {}
                     ]]}}
      [:img.mr-1.mb-1
       {:style {:width "17px"}
        :src "/img/link.svg"}]
      [:span.text-lg
       {:style {:fontFamily "AvenyT"
                :-webkit-background-clip "text"
                :-webkit-text-fill-color "transparent"
                :background-image "linear-gradient(90deg, #2cbdec, #2f2e96)"}}
       "LINK"]]]

    [:li.col-span-1.rounded-lg.shadow.divide-y.divide-gray-200.bg-white
     [:button.w-full.flex.items-center.justify-center.rounded-md.p-2
      {:type "button"
       :on {:click [[:data/query {:query/kind :query/ig-account-data}]
                    [:ui/modal-open
                     :modals/editor2-location-modal
                     {}
                     ]]}}
      [:span
       {:style {:color "#a100b2"
                :fontFamily "AvenyT"
                :-webkit-background-clip "text"
                :-webkit-text-fill-color "transparent"
                :background-image "linear-gradient(90deg, #a100b2, #2701ef)"}}
       [:i.fas.fa-map-marker-alt] " LOCATION"]]]

    [:li.col-span-1.rounded-lg.shadow.divide-y.divide-gray-200.bg-white.relative
     [:span
      {:class ["absolute" "top-0" "right-0" "px-1.5" "py-0.5" "text-[9px]"
               "font-bold" "leading-none" "text-white" "bg-red-500"
               "rounded-full" "uppercase" "tracking-wide"
               "pointer-events-none"]}
      "NEW"]
     [:button.w-full.flex.items-center.justify-center.rounded-md.p-2
      {:type "button"
       :on {:click [[:data/query {:query/kind :query/ig-account-data}]
                    [:ui/modal-open
                     :modals/editor2-music-modal
                     {}
                     ]]}}
      [:span
       {:style {:fontFamily "AvenyT"
                :-webkit-background-clip "text"
                :-webkit-text-fill-color "transparent"
                :background-image "linear-gradient(90deg, #d300c5, #ff0069)"}}
       [:i.fas.fa-music] " MUSIC"]]]

    [:li.col-span-1.rounded-lg.shadow.divide-y.divide-gray-200.bg-white
     [:button.w-full.flex.items-center.justify-center.rounded-md.p-2
      {:type "button"
       :on {:click [[:ui/modal-open
                     :modals/editor2-poll-modal
                     {:source :editor2}                        ;; params map
                     ]]}}
      [:span
       {:style {:fontFamily "AvenyT"
                :-webkit-background-clip "text"
                :-webkit-text-fill-color "transparent"
                :background-image "linear-gradient(90deg, #00baff, #3acc38)"}}
       [:span.mr-1
        {:style {:color "#00baff"}}
        [:i.fas.fa-poll]]
       "POLL"]]]

    [:li.col-span-1.rounded-lg.shadow.divide-y.divide-gray-200.bg-white
     [:button.w-full.flex.items-center.justify-center.rounded-md.p-2
      {:type "button"
       :on {:click [[:ui/modal-open
                     :modals/editor2-question-modal
                     {}]]}}
      [:span
       {:style {:fontFamily "AvenyT"
                :-webkit-background-clip "text"
                :-webkit-text-fill-color "transparent"
                :background-image "linear-gradient(90deg, #bc00af, #f60008)"}}
       "QUESTIONS"]]]

    [:li.col-span-1.rounded-lg.shadow.divide-y.divide-gray-200.bg-white.text-gray-600
     [:button.w-full.flex.items-center.justify-center.rounded-md.p-2
      {:type "button"
       :on {:click [[:ui/modal-open
                     :modals/editor2-countdown-modal
                     {}]]}}
      [:span
       {:style {:fontFamily "AvenyT"}}
       [:i.fas.fa-clock.mr-1]
       "COUNTDOWN"]]]

    [:li.col-span-1.rounded-lg.shadow.divide-y.divide-gray-200.bg-white.text-gray-600
     [:button.w-full.flex.items-center.justify-center.rounded-md.p-2
      {:type "button"
       :on {:click [[:ui/modal-open
                     :modals/editor2-quiz-modal
                     {}]]}}
      [:span
       {:style {:fontFamily "AvenyT"}}
       [:i.fas.fa-poll-h.mr-1]
       "QUIZ"]]]

    [:li.col-span-1.rounded-lg.shadow.divide-y.divide-gray-200.bg-white
     [:button.w-full.flex.items-center.justify-center.rounded-md.p-2
      {:type "button"
       :on {:click [[:ui/modal-open
                     :modals/editor2-emoji-slider-modal
                     {}]]}}
      [:span
       {:style {:fontFamily "AvenyT"}}
       [:img
        {:style {:max-width "100px"}
         :src "/img/slider.png"}]]]]]])